"use server";

// Auth server actions (PLG: reps self-serve). Cookies are set server-side via
// the Supabase server client; the proxy refreshes the session thereafter.

import { redirect } from "next/navigation";
import { createSupabaseServerClient } from "@/lib/platform/supabase/server";

export type AuthState = { error: string } | undefined;

export async function login(
  _prev: AuthState,
  formData: FormData,
): Promise<AuthState> {
  const email = String(formData.get("email") ?? "").trim();
  const password = String(formData.get("password") ?? "");
  const supabase = await createSupabaseServerClient();
  const { error } = await supabase.auth.signInWithPassword({ email, password });
  if (error) return { error: error.message };
  redirect("/today");
}

export async function signup(
  _prev: AuthState,
  formData: FormData,
): Promise<AuthState> {
  const email = String(formData.get("email") ?? "").trim();
  const password = String(formData.get("password") ?? "");
  const firstName = String(formData.get("first_name") ?? "").trim();
  const supabase = await createSupabaseServerClient();
  const { data, error } = await supabase.auth.signUp({
    email,
    password,
    options: { data: { first_name: firstName } },
  });
  if (error) return { error: error.message };
  // Local dev may auto-confirm (session present → straight in). If confirmations
  // are on, the rep confirms via email (Inbucket/mailpit locally) then logs in.
  if (data.session) redirect("/today");
  return { error: "Account created — confirm your email, then log in." };
}

// Single entry the form calls; branches on the hidden `mode` field.
export async function authenticate(
  prev: AuthState,
  formData: FormData,
): Promise<AuthState> {
  return formData.get("mode") === "signup"
    ? signup(prev, formData)
    : login(prev, formData);
}

export async function logout(): Promise<void> {
  const supabase = await createSupabaseServerClient();
  await supabase.auth.signOut();
  redirect("/login");
}
